import { render } from "./ModalTerm.vue?vue&type=template&id=82a4c152&scoped=true&ts=true"
import script from "./ModalTerm.vue?vue&type=script&lang=ts"
export * from "./ModalTerm.vue?vue&type=script&lang=ts"

import "./ModalTerm.vue?vue&type=style&index=0&id=82a4c152&scoped=true&lang=css"

import exportComponent from "/app/purple__bee/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-82a4c152"]])

export default __exports__